var _circle, _circle2, _path, _path2, _path3, _circle3, _ellipse, _ellipse2, _ellipse3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCosmos(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 2500 2500",
    width: "1em",
    height: "1em"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 1250,
    cy: 1250,
    r: 1250,
    fill: "#2e3148"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 1250,
    cy: 1250,
    r: 725.31,
    fill: "#1b1e36"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1252.57 159.47c-134.93 0-244.34 489.4-244.34 1093.11s109.41 1093.11 244.34 1093.11 244.34-489.4 244.34-1093.11S1387.5 159.47 1252.57 159.47zM1269.44 2284c-15.43 20.58-30.86 5.14-30.86 5.14-62.14-72-93.21-205.76-93.21-205.76-108.69-349.79-82.82-1100.82-82.82-1100.82 51.08-596.24 144-737.09 175.62-768.36a19.29 19.29 0 0124.74-2c45.88 32.51 84.36 168.47 84.36 168.47 113.63 421.81 103.34 817.9 103.34 817.9 10.29 344.65-56.94 730.45-56.94 730.45-51.75 293.2-124.23 354.98-124.23 354.98z",
    fill: "#6f7390"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2200.72 708.59c-67.18-117.08-546.09 31.58-1070 332s-893.47 638.89-826.34 755.92 546.09-31.58 1070-332 893.47-638.89 826.34-755.92zM366.36 1780.45c-25.72-3.24-19.91-24.38-19.91-24.38 31.55-89.71 131.95-183.23 131.95-183.23 249.43-268.36 913.79-619.65 913.79-619.65 542.54-252.42 711.06-241.77 753.81-230a19.29 19.29 0 0114 20.58c-5.14 56-104.17 157-104.17 157-309.12 308.59-657.83 496.81-657.83 496.81-293.83 180.5-661.93 314.09-661.93 314.09-280.09 100.93-369.7 68.78-369.7 68.78z",
    fill: "#6f7390"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2198.35 1800.41c67.7-116.77-300.93-456.79-823-759.47S374.43 587.76 306.79 704.73s300.93 456.79 823.3 759.47 1000.62 453.19 1068.26 336.21zM351.65 749.85c-10-23.71 11.11-29.42 11.11-29.42C456.22 702.78 587.5 743 587.5 743c357.15 81.33 994 480.25 994 480.25 490.33 343.11 565.53 494.24 576.8 537.14a19.29 19.29 0 01-10.7 22.43c-51.13 23.41-188.07-11.47-188.07-11.47-422.07-113.17-759.62-320.52-759.62-320.52-303.29-163.58-603.19-415.28-603.19-415.28-227.88-191.87-245-285.44-245-285.44z",
    fill: "#6f7390"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 1250,
    cy: 1250,
    r: 128.6,
    fill: "#b7b9c8"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1777.26,
    cy: 756.17,
    rx: 74.59,
    ry: 77.16,
    fill: "#b7b9c8"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 552.98,
    cy: 1018.52,
    rx: 74.59,
    ry: 77.16,
    fill: "#b7b9c8"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1098.25,
    cy: 1965.02,
    rx: 74.59,
    ry: 77.16,
    fill: "#b7b9c8"
  })));
}

export default SvgCosmos;